import fifthEdition from "./fifthEdition";

const ruleset = fifthEdition;

export default ruleset;
